import {
  CREATE_EXCEL_TAX_RATE_FAILURE,
  CREATE_EXCEL_TAX_RATE_REQUEST,
  CREATE_EXCEL_TAX_RATE_SUCCESS,
  DELETE_EXCEL_TAX_RATE_FAILURE,
  DELETE_EXCEL_TAX_RATE_REQUEST,
  DELETE_EXCEL_TAX_RATE_SUCCESS,
  DELETE_TAX_RATE_TEMPLATE_FAILURE,
  DELETE_TAX_RATE_TEMPLATE_REQUEST,
  DELETE_TAX_RATE_TEMPLATE_SUCCESS,
  UPDATE_EXCEL_TAX_RATE_NAME_FAILURE,
  UPDATE_EXCEL_TAX_RATE_NAME_REQUEST,
  UPDATE_EXCEL_TAX_RATE_NAME_SUCCESS,
  EDIT_TAX_RATE_TEMPLATE_NAME_FAILURE,
  EDIT_TAX_RATE_TEMPLATE_NAME_REQUEST,
  EDIT_TAX_RATE_TEMPLATE_NAME_SUCCESS,
  FETCH_TAX_RATES_BY_COUNTRY_FAILURE,
  FETCH_TAX_RATES_BY_COUNTRY_REQUEST,
  FETCH_TAX_RATES_BY_COUNTRY_SUCCESS,
  GET_TAX_RATE_TEMPLATES_FAILURE,
  GET_TAX_RATE_TEMPLATES_REQUEST,
  GET_TAX_RATE_TEMPLATES_SUCCESS,
  SAVE_TAX_RATE_TEMPLATE_FAILURE,
  SAVE_TAX_RATE_TEMPLATE_REQUEST,
  SAVE_TAX_RATE_TEMPLATE_SUCCESS,
  SAVE_TAX_RATES_FAILURE,
  SAVE_TAX_RATES_REQUEST,
  SAVE_TAX_RATES_SUCCESS,
  SET_GETTING_TAXES,
} from './constants';
import {
  FetchTaxRatesByCountrySuccessAction,
  GetTaxRateTemplatesSuccessAction,
  SaveTaxRatesSuccessAction,
  SetGettingTaxesAction,
  TaxRatesAction,
  TaxRatesState,
  UpdateExcelTaxRateNameFailureAction,
  UpdateExcelTaxRateNameRequestAction,
} from './types';

const initialState: TaxRatesState = {
  loading: false,
  gettingTaxes: false,
  taxRateTemplates: undefined,
  taxRatesByCountry: undefined,
  byConnectionId: {},
};

export const taxRatesReducer = (
  state = initialState,
  action: TaxRatesAction
): TaxRatesState => {
  switch (action.type) {
    case SAVE_TAX_RATE_TEMPLATE_REQUEST:
    case GET_TAX_RATE_TEMPLATES_REQUEST:
    case DELETE_TAX_RATE_TEMPLATE_REQUEST:
    case DELETE_EXCEL_TAX_RATE_REQUEST:
    case EDIT_TAX_RATE_TEMPLATE_NAME_REQUEST:
    case CREATE_EXCEL_TAX_RATE_REQUEST:
    case FETCH_TAX_RATES_BY_COUNTRY_REQUEST:
    case SAVE_TAX_RATES_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case UPDATE_EXCEL_TAX_RATE_NAME_REQUEST:
      return handleUpdateExcelTaxRateNameRequest(
        state,
        action as UpdateExcelTaxRateNameRequestAction
      );

    case GET_TAX_RATE_TEMPLATES_SUCCESS:
      return handleGetTaxRateTemplatesSuccess(
        state,
        action as GetTaxRateTemplatesSuccessAction
      );

    case FETCH_TAX_RATES_BY_COUNTRY_SUCCESS:
      return handleFetchTaxRatesByCountrySuccess(
        state,
        action as FetchTaxRatesByCountrySuccessAction
      );

    case SAVE_TAX_RATES_SUCCESS:
      return handleSaveTaxRatesSuccess(
        state,
        action as SaveTaxRatesSuccessAction
      );

    case SAVE_TAX_RATE_TEMPLATE_SUCCESS:
    case DELETE_TAX_RATE_TEMPLATE_SUCCESS:
    case DELETE_EXCEL_TAX_RATE_SUCCESS:
    case EDIT_TAX_RATE_TEMPLATE_NAME_SUCCESS:
    case CREATE_EXCEL_TAX_RATE_SUCCESS:
      return handleSuccess(state);

    case UPDATE_EXCEL_TAX_RATE_NAME_SUCCESS:
      return handleUpdateExcelTaxRateNameSuccess(state);

    case SAVE_TAX_RATE_TEMPLATE_FAILURE:
    case GET_TAX_RATE_TEMPLATES_FAILURE:
    case DELETE_TAX_RATE_TEMPLATE_FAILURE:
    case DELETE_EXCEL_TAX_RATE_FAILURE:
    case EDIT_TAX_RATE_TEMPLATE_NAME_FAILURE:
    case CREATE_EXCEL_TAX_RATE_FAILURE:
    case FETCH_TAX_RATES_BY_COUNTRY_FAILURE:
    case SAVE_TAX_RATES_FAILURE:
      return handleFailure(state);

    case UPDATE_EXCEL_TAX_RATE_NAME_FAILURE:
      return handleUpdateExcelTaxRateNameFailure(
        state,
        action as UpdateExcelTaxRateNameFailureAction
      );

    case SET_GETTING_TAXES:
      return handleSetGettingTaxes(state, action as SetGettingTaxesAction);

    default:
      return state;
  }
};

function handleGetTaxRateTemplatesSuccess(
  state: TaxRatesState,
  action: GetTaxRateTemplatesSuccessAction
): TaxRatesState {
  const { templates } = action.payload;

  return {
    ...state,
    loading: false,
    taxRateTemplates: templates,
  };
}

function handleFetchTaxRatesByCountrySuccess(
  state: TaxRatesState,
  action: FetchTaxRatesByCountrySuccessAction
): TaxRatesState {
  const { taxRates, countryId } = action.payload;

  return {
    ...state,
    loading: false,
    taxRatesByCountry: {
      countryId,
      taxRates,
    },
  };
}

function handleSaveTaxRatesSuccess(
  state: TaxRatesState,
  action: SaveTaxRatesSuccessAction
): TaxRatesState {
  const { taxRates, connectionId } = action.payload;
  const ratesArray = Array.isArray(taxRates) ? taxRates : [];

  return {
    ...state,
    loading: false,
    byConnectionId: {
      ...state.byConnectionId,
      [connectionId]: [...ratesArray],
    },
  };
}

function handleSetGettingTaxes(
  state: TaxRatesState,
  action: SetGettingTaxesAction
): TaxRatesState {
  return {
    ...state,
    loading: false,
    gettingTaxes: action.payload.gettingTaxes,
  };
}

function handleUpdateExcelTaxRateNameRequest(
  state: TaxRatesState,
  _action: UpdateExcelTaxRateNameRequestAction
): TaxRatesState {
  return {
    ...state,
    loading: true,
    taxRateNameUpdateFailureTaxType: null,
  };
}

function handleUpdateExcelTaxRateNameSuccess(
  state: TaxRatesState
): TaxRatesState {
  return {
    ...state,
    loading: false,
    taxRateNameUpdateFailureTaxType: null,
  };
}

function handleUpdateExcelTaxRateNameFailure(
  state: TaxRatesState,
  action: UpdateExcelTaxRateNameFailureAction
): TaxRatesState {
  return {
    ...state,
    loading: false,
    taxRateNameUpdateFailureTaxType: action.payload.taxType,
  };
}

function handleSuccess(state: TaxRatesState): TaxRatesState {
  return {
    ...state,
    loading: false,
  };
}

function handleFailure(state: TaxRatesState): TaxRatesState {
  return {
    ...state,
    loading: false,
  };
}
